import React from "react";
import { useTranslations } from "../../../contexts";

export const BillingTab: React.FC = () => {
  const i18n = useTranslations();
  return <p>{i18n["Contact us"]}</p>;
};
